class AgentDownloadLinkController {
  constructor(config, $http, agentDownloadLinkService) {
    this.name = 'agentDownloadLink';
    this.$http = $http;
    this.config = config;
    this.agentDownloadLinkService = agentDownloadLinkService;
    this.hasDownloadLink = false;
    this.downloadLink = '';
  }

  getDownloadLink() {
    return this.downloadLink || '#';
  }

  getSignedDownloadUrl() {
    this.agentDownloadLinkService.getAgentDownloadLink().then((results)=>{
      let content = results.data.content;
      if(content) {
        this.downloadLink = content.updateDownloadURL;
        this.hasDownloadLink = true;
      }
    });
  }
}

AgentDownloadLinkController.$inject = ['config', '$http', 'agentDownloadLinkService'];

export default AgentDownloadLinkController;



// WEBPACK FOOTER //
// ./app/components/agentDownloadLink/agentDownloadLink.controller.js